/* jslint browser: true */
/* global document */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import 'react-table/react-table.css';
import { removeFromArray }  from '../helpers';

class Jours extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jours : [
                { nom: 'Lundi',    value: 1 },
                { nom: 'Mardi',    value: 2 },
                { nom: 'Mercredi', value: 3 },
                { nom: 'Jeudi',    value: 4 },
                { nom: 'Vendredi', value: 5 },
                { nom: 'Samedi',   value: 6 },
            ],
            jourStyle : {},
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.setState({ jourStyle: { width: (document.querySelector('.jours-form').offsetWidth / 7) - 10 } });
    }

    /**
     * Récupere chaque modification des champs du formulaire (onChange)
     * @param  {Event} e - Evenement (onChange) des champs
     */
    handleChange(e) {
        const menuJours = this.props.model.slice();
        if (e.target.checked) { menuJours.push(e.target.value); } else { removeFromArray(menuJours, e.target.value); }
        this.props.updateJours(menuJours);
    }

    render() {
        return (
            <div className="jours-form" style={{ width: this.props.width, textAlign: 'center' }}>
                <h3 className="no-style">JOUR DE LA SEMAINE</h3>
                <div className="form-row" >
                    {
                        this.state.jours.map(jour => (
                            <div className="jour" key={jour.value} style={this.state.jourStyle}>
                                <label htmlFor={jour.nom}>{jour.nom}
                                    <input
                                        type="checkbox"
                                        name={jour.nom}
                                        onChange={e => this.handleChange(e)}
                                        value={jour.value}
                                        checked={this.props.model.indexOf(`${jour.value}`) !== -1}
                                    />
                                </label>
                            </div>))
                    }
                </div>
            </div>
        );
    }
}

// Declaration des props du composant
Jours.propTypes = { width: PropTypes.string, model: PropTypes.array, updateJours: PropTypes.func };
// Définition par defaut (si non-attribué a l'appel du composant) des props
Jours.defaultProps = { width: '100%', model: [], updateJours: () => undefined };

export default Jours;



// WEBPACK FOOTER //
// ./src/components/Jours.js